<script setup lang="ts">
    const { locale } = useI18n();
    const { $keycloak } = useNuxtApp();
    import { computed } from 'vue';

    const collectUrl = computed(() => {
        return locale.value && locale.value !== 'en'
            ? `https://collect.whaleden.com/${locale.value}`
            : 'https://collect.whaleden.com';
    });

    const shopUrl = computed(() => {
        return locale.value && locale.value !== 'en'
            ? `https://shop.whaleden.com/${locale.value}`
            : 'https://shop.whaleden.com';
    });

    defineProps<{
        fixed?: boolean;
    }>();

    const signup = () => {
        const redirectUri =
            locale.value && locale.value !== 'en'
                ? `${window.location.origin}/${locale.value}/account'`
                : `${window.location.origin}/account`;
        $keycloak.register({ redirectUri });
    };

    const signin = () => {
        const redirectUri =
            locale.value && locale.value !== 'en'
                ? `${window.location.origin}/${locale.value}/account`
                : `${window.location.origin}/account`;
        $keycloak.login({ redirectUri, locale: locale.value });
    };

    const logout = async () => {
        const redirectUri =
            locale.value && locale.value !== 'en'
                ? `${window.location.origin}/${locale.value}`
                : window.location.origin;
        $keycloak.logout({ redirectUri });
    };

    const route = useRoute();
</script>

<template>
    <div class="block lg:z-[1000] mt-4 lg:mt-0 !relative">
        <div class="lg:hidden">
            <div
                class="lg:absolute z-20 flex space-x-2 lg:right-4 lg:bottom-auto lg:left-auto lg:top-4"
                v-if="!$keycloak?.authenticated"
            >
                <div class="shadow-2xl shadow-black/80 rounded-md">
                    <AppButton @click="signin">{{ $t('header.sign_in') }}</AppButton>
                </div>

                <div class="shadow-2xl shadow-black/80 rounded-md">
                    <AppButton isSecondary @click="signup">{{ $t('header.sign_up') }}</AppButton>
                </div>
            </div>
            <div
                v-if="$keycloak?.authenticated"
                class="lg:absolute z-20 relative space-x-2 w-fit shadow-black/80 lg:right-4 lg:bottom-auto lg:left-auto lg:top-4 rounded-md"
            >
                <AppButton
                    class="shadow-2xl"
                    @click="
                        () => {
                            $emit('close');
                            $router.push(locale && locale !== 'en' ? `/${locale}/account` : '/account');
                        }
                    "
                >
                    {{ $t('header.account') }}
                </AppButton>
                <AppButton isSecondary class="shadow-2xl" @click="logout"> {{ $t('header.sign_out') }}</AppButton>
            </div>
        </div>

        <div
            class="lg:absolute hidden lg:flex z-20 space-x-2 lg:right-4 lg:bottom-auto lg:left-auto lg:top-4"
            v-if="!$keycloak?.authenticated"
        >
            <!--  <div class="shadow-2xl shadow-black/80 rounded-md">
                <AppButton @click="signin">{{$t('header.sign_in')}}</AppButton>
            </div>

            <div class="shadow-2xl shadow-black/80 rounded-md">
                <AppButton isSecondary @click="signup">{{$t('header.sign_up')}}</AppButton>
            </div> -->
        </div>

        <div
            :class="fixed ? 'lg:fixed mt-2 lg:mt-5' : ' lg:absolute  mt-2 lg:mt-4'"
            class="hidden lg:block relative z-20 lg:right-4 w-fit border-black/20 shadow-black/80 lg:top-0 rounded-md"
        >
            <div class="md:flex lg:space-x-1.5 space-y-2 md:space-y-0">
                <HeaderSignInPopover />
            </div>
        </div>

        <div
            class="tracking-tight lg:hidden left-0 flex-col flex lg:px-12 lg:flex-row text-black py-6 gap-4 lg:gap-12 xl:justify-center lg:absolute top-0 right-0"
        >
            <a
                v-if="$keycloak?.authenticated"
                :href="collectUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="font-medium border-b-4 pb-1 w-fit border-opacity-10 cursor-pointer hover:border-opacity-100 border-primary"
            >
                {{ $t('onboard.bonus.sections.whaleden.cta') }}
            </a>

            <a
                :href="shopUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="font-medium border-b-4 pb-1 w-fit border-opacity-10 cursor-pointer hover:border-opacity-100 border-primary"
            >
                {{ $t('navbar.shop') }}
            </a>

            <Button
                @click="
                    () => {
                        $emit('close');
                        $router.push(locale && locale !== 'en' ? `/${locale}/blog` : '/blog');
                    }
                "
                rel="noopener noreferrer"
                class="font-medium border-b-4 pb-1 w-fit border-opacity-10 cursor-pointer hover:border-opacity-100 border-primary"
            >
                {{ $t('navbar.blog') }}
            </Button>
        </div>
        <AppLanguageSwitcher
            class="border-b-4 pb-1 w-fit border-opacity-10 cursor-pointer hover:border-opacity-100 border-primary"
            dapp
            reverse
        />
    </div>
</template>

<style scoped></style>
